import NetworkError from "../../components/NetworkError";
import Preloader from "../../components/Preloader";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { config } from "../../constants/config";
import { useEffect } from "react";
import { Lock } from "react-bootstrap-icons";
import UserContext from "../../contexts/UserContext";
import { textes } from "../../constants/textes";



export default function UpdatePass({ code }) {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [error, setError] = useState(false);

    const [login, setLogin] = useState("");
    const [password, setPassword] = useState("");
    const [newpass, setNewpass] = useState("");
    const [confirmpass, setConfirmpass] = useState("");
    const [codecompte, setCodecompte] = useState('');


    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }


    const getCompte = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/accounts/${user?.code}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let body = data?.body?.data[0];

                        setCodecompte(body?.code !== null ? body?.code : "");
                        setLogin(body?.login !== null ? body?.login : "");

                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }

        })
            .catch((err) => {
                // console.log("error", err);
                setError(true);
                setLoading(false);
            });
    }


    // comportements
    useEffect(() => {
        getCompte();
    }, []);

    const handlelogout = async () => {
        // setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        // var urlencoded = new URLSearchParams();

        var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/connections/deconnexion`, requestOptions).then((response) => {
            if (response?.status === 204) {
                logoutUser();
                setFetching(false);
                navigate("/");
            } else if (response?.status === 200) {
                response.json().then(async (data) => {
                    if (!data?.head) {
                        setFetching(false);
                        showErrorMessage(data?.body?.data?.msg);
                    }
                })
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setFetching(false);
                showErrorMessage('Service indisponible! Reessayez plutard.');
            }
        }).catch((err) => {
            setFetching(false);
            showErrorMessage(config.texts.unavailblemsg, err);
        })

    }

    const handleUpdate = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();

        urlencoded.append("login", login);
        urlencoded.append("mdp", newpass);

        var requestOptions = {
            method: 'PATCH',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/accounts/${codecompte}`, requestOptions).then((response) => {
            if (response?.status === 205) {
                showSuccesMessage("Password updated successfully.");
                handlelogout();
            } else if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse update rule", data);
                    // let body = data?.body;

                    if (data?.body?.data?.msg === "expiredsession") {
                        logoutUser();
                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                    } else {
                        setFetching(false);
                        showErrorMessage(data?.body?.data?.msg);
                    }

                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // setError(true);
                showErrorMessage(textes.fr.serviceunavaillable);
                setFetching(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            // setError(true);
            showErrorMessage(config.texts.unavailblemsg);
            setFetching(false);
        });

    }

    const handleSubmitEdit = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: 'Update?',
            message: 'Are you sure you want tu update your password?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setFetching(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.secure.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();
                        urlencoded.append("login", login);
                        urlencoded.append("mdp", password);

                        var requestOptions = {
                            method: 'POST',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        // console.log("data send", urlencoded)

                        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/login`, requestOptions).then((response) => {
                            if (response?.status === 200 || response?.status === 201) {
                                response.json().then(async (data) => {
                                    // console.log("resonse ajout droit", data);
                                    if (!data?.head) {
                                        if (data?.body?.data?.msg === "expiredsession") {
                                            logoutUser();
                                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                        } else {
                                            showErrorMessage(data?.body?.data?.msg);
                                        }
                                    } else {
                                        let body = data?.body?.data;

                                        if (body?.ident && !body?.auth) {
                                            showErrorMessage("Invalid current password.");
                                        } else {

                                            handleUpdate();

                                        }
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // console.log("resonse ", response);
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setFetching(false);
                            }

                        })
                            .catch((err) => {
                                // console.log("error", err);
                                // setError(true);
                                showErrorMessage(config.texts.unavailblemsg);
                                setFetching(false);
                            });
                    }
                },
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }



    // affichages
    return (
        <>
            {loading && <Preloader />}
            {!loading && error && <NetworkError />}
            {!loading && !error && <div className="row">
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quit" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                        <i className="fa fa-reply"></i> <span>Go Back</span>
                                    </button>

                                    <h6 className="m-0 ">Update your password</h6>
                                </div>
                                <div className="card-body">
                                    <form style={{ width: "100%" }} onSubmit={handleSubmitEdit}>
                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <div className="row">
                                                    <div className="col-md-12 mb-3">
                                                        <label htmlFor="pass" className="mb-1">Current password</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="pass">
                                                                <Lock />
                                                            </span>
                                                            <input type="password"
                                                                className="form-control"
                                                                placeholder="Enter your current password"
                                                                value={password}
                                                                onChange={(e) => setPassword(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <label htmlFor="pass" className="mb-1">New password</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="pass">
                                                                <Lock />
                                                            </span>
                                                            <input type="password"
                                                                className="form-control"
                                                                placeholder="Enter new password"
                                                                value={newpass}
                                                                onChange={(e) => setNewpass(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <label htmlFor="confirmpass" className="mb-1">Confirme new password</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="confirmpass">
                                                                <Lock />
                                                            </span>
                                                            <input type="password"
                                                                className="form-control"
                                                                placeholder="Enter new password confirmation"
                                                                value={confirmpass}
                                                                onChange={(e) => setConfirmpass(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                            <div className="col-md-12 mt-2">
                                                <button type="submit"
                                                    title="Update your password"
                                                    className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                    disabled={password && newpass && newpass === confirmpass ? false : true}
                                                >
                                                    <i className="fa fa-check mr-2"></i>
                                                    <span>Update</span> {fetching && <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />}
                                                </button>
                                                {/* <button onClick={() => setEditedstate(false)} 
                                                    title="Cancel operation"
                                                    className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                                    <i className="fa fa-reply mr-1"></i> <span>Cancel</span>
                                                </button> */}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ToastContainer />
                </div>
            </div>}
        </>
    )
}